export default {
  default: {
    backgroundColor: 'inherit',
    border: 1,
    borderColor: 'border',
    variant: 'text.small',
  },

  empty: {},

  text: {
    border: 0,
    color: 'inherit',
    backgroundColor: 'transparent',
    variant: 'text.small',
  },

  primary: {
    backgroundColor: 'primary',
    color: 'onPrimary',
    paddingX: 3,
    border: 0,
    ':hover': { color: 'onPrimary' },
  },
};
